import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

/**
 * Sends a user on to their own landing page when /home is not it — today that is
 * ADMIN and SU, who belong on the countries browser.
 *
 * DIRECTOR stays: /home is the competitions page, scoped to the competitions they hold,
 * which is the landing the role is meant to have. PLAYER and COACH are claimed by their
 * own guards ahead of this one, so those branches of getHomeRoute() never fire here;
 * they are still the rule for the navbar and the access denied page.
 *
 * Every redirecting guard RETURNS its UrlTree rather than calling router.navigate().
 * A navigate() from inside a guard starts a second navigation that pushes its own
 * history entry, so Back from the landing page returned to /home, which redirected
 * forward again and Back appeared dead. A returned UrlTree replaces the entry when the
 * navigation came from Back or a fresh load, and keeps the origin page after a click.
 *
 * The comparison has to be on the joined path. Comparing the arrays would always differ
 * and this guard would bounce /home to /home on every load.
 */
export const homeRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const home = authService.getHomeRoute()
  if (home.join('/') !== '/home') {
    return router.createUrlTree(home)
  }

  return true
}
